<template>
  <el-row>
    <el-row class="sj-container">
      <el-table :highlight-current-row="true"
                :data="table"
                :show-header="false"
                border>
        <el-table-column width="150"
                         prop="label">
          <template slot-scope="scope">
            <b>{{scope.row.label}}</b>
          </template>
        </el-table-column>
        <el-table-column min-width="150">
          <template slot-scope="scope">
            <span
              v-if="!ifKey(scope, 'managementfees') && !ifKey(scope, 'totalspentmoney') && !ifKey(scope, 'ongoingtasknum') && !ifKey(scope, 'operation') && !ifKey(scope, 'balance')">
              {{detailData[scope.row.key]}}
            </span>
            <span v-if="ifKey(scope, 'managementfees')">
              {{parseInt(detailData[scope.row.key]*100)}}%
            </span>
            <span v-if="ifKey(scope, 'totalspentmoney')">
              {{getFixedValue(detailData[scope.row.key])}} (管理费: {{getFixedValue(detailData['totalmanagementfee'])}})
            </span>
            <span v-if="ifKey(scope, 'ongoingtasknum')">
              {{detailData[scope.row.key]}} (奖金总额: {{getFixedValue(detailData['ongoingtaskmoney'])}})
            </span>
            <span v-if="ifKey(scope, 'balance')">
              {{getFixedValue(detailData[scope.row.key])}}
            </span>
            <span v-if="ifKey(scope, 'operation')">
              客户订单列表 |
              <router-link
                :to="{ path: '/teke_customer/balance/table/'+detailData['id']+'?customername='+detailData['name']}">
                <el-button type="text">客户消费流水</el-button>
              </router-link>|
              <router-link
                :to="{ path: '/teke_customer/recharge/table/'+detailData['id']+'?customername='+detailData['name']}">
                <el-button type="text">客户充值记录</el-button>
              </router-link>

            </span>
          </template>
        </el-table-column>
      </el-table>

    </el-row>
  </el-row>

  </div>
</template>

<script>

export default {
  components: {},
  data () {
    return {
      detailData: {
        id: this.$route.params.id,
        number: null,
        name: null,
        company: null,
        managementfees: null,
        balance: null,
        freezing: null,
        totalspentmoney: null,
        ongoingtaskmoney: null,
        totalhirenum: null,
        ongoingtasknum: null,
        totalmanagementfee: null,
        totaltasknum: null,
      },

      table: [
        {
          key: 'id',
          label: '客户ID',
        },
        {
          key: 'number',
          label: '客户唯一编号',
        },
        {
          key: 'name',
          label: '客户名',
        },
        {
          key: 'company',
          label: '客户公司',
        },
        {
          key: 'managementfees',
          label: '客户管理费率',
        },
        {
          key: 'balance',
          label: '客户当前余额',
        },
        {
          key: 'freezing',
          label: '客户当前冻结金额',
        },
        {
          key: 'totalspentmoney',
          label: '客户总消费金额',
        },
        {
          key: 'totaltasknum',
          label: '客户总投放工单数',
        },
        {
          key: 'totalhirenum',
          label: '客户总雇佣人数',
        },
        {
          key: 'ongoingtasknum',
          label: '客户当前进行中的工单数',
        },
        {
          key: 'operation',
          label: '操作',
        },
      ],

    }
  },
  computed: Vuex.mapState({}),
  created () {
    this.setFormData()
  },
  methods: {
    ...Vuex.mapActions(['getTekeCustomerDetail']),
    ifKey (scope, name) {
      return scope.row.key === name
    },
    setFormData () {
      return request.page('getTekeCustomerDetail', this.detailData.id).then(({data}) => {
        filter.setLoop(this.detailData, data)
      })
    },
    getValue (scope, name) {
      return this.detailData[scope.row.key][name]
    },
    getFixedValue (value) {
      let number = parseFloat(value)
      return number.toFixed(2)
    },
  },
}
</script>
<style lang="scss"
       scoped></style>



// WEBPACK FOOTER //
// src/views/teke-customer/pages/TekeCustomerDetail.vue